import script from "./specialOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./specialOrder.vue?vue&type=script&setup=true&lang=js"

import "./specialOrder.vue?vue&type=style&index=0&id=0bd0b0fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd0b0fe"]])

export default __exports__